import styles from "./styles/styles";

export default {
    key: "f0217d4c-60dd-4416-91f2-67f2e7f1426c",
    data: {
        state: {
            components: {
                introOverlay: {
                    open: true
                },
                visualizations: {
                    activeSection: "riskAssessment",
                    riskAssessmentActiveSection: "zones"
                }
            },
            maps: {
                activeMapKey: "risk-assessment-big",
                activeSetKey: "risk-assessment",
                maps: {
                    "interferometry-big": {
                        key: "interferometry-big",
                        data: {}
                    },
                    "interferometry-small": {
                        key: "interferometry-small",
                        data: {}
                    },
                    "risk-assessment-big": {
                        key: "risk-assessment-big",
                        data: {}
                    },
                    "risk-assessment-small": {
                        key: "risk-assessment-small",
                        data: {
                            view: {
                                boxRange: 1000
                            }
                        }
                    }
                },
                sets: {
                    interferometry: {
                        key: "interferometry",
                        activeMapKey: "interferometry-big",
                        maps: ["interferometry-big", "interferometry-small"],
                        sync: {
                            center: true
                        },
                        data: {
                            backgroundLayer: {
                                key: "imagery",
                                name: "ESRI World Imagery",
                                options: {
                                    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
                                    maxNativeZoom: 17
                                },
                                type: "wmts"
                            },
                            view: {
                                boxRange: 500,
                                center: {
                                    lat: 23.0266,
                                    lon: 93.7070
                                }
                            },
                            viewLimits: {
                                boxRangeRange: [null, 10000]
                            }
                        }
                    },
                    "risk-assessment": {
                        key: "risk-assessment",
                        activeMapKey: "risk-assessment-big",
                        maps: ["risk-assessment-big", "risk-assessment-small"],
                        sync: {
                            center: true
                        },
                        data: {
                            backgroundLayer: {
                                key: "imagery",
                                name: "ESRI World Imagery",
                                options: {
                                    url: "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",
                                    maxNativeZoom: 17
                                },
                                type: "wmts"
                            },
                            view: {
                                boxRange: 8000,
                                center: {
                                    lat: 23.0266,
                                    lon: 93.7070
                                }
                            },
                            viewLimits: {
                                boxRangeRange: [500, null]
                            }
                        }
                    }
                }
            },
            selections: {
                activeKey: "riskAssessmentZones",
                data: [
                    {
                        key: 'riskAssessmentZones',
                        data: {
                            color: "#00fffe",
                            hoveredColor: "#1efbff"
                        }
                    },
                    {
                        key: 'riskAssessmentRoads',
                        data: {
                            style: {
                                outlineColor: "#00fffe",
                                outlineWidth: 7
                            }
                        }
                    },
                    {
                        key: 'interferometry',
                        data: {
                            color: "#00fffe",
                            hoveredColor: "#1efbff"
                        }
                    }
                ]
            },
            styles: {
                data: Object.values(styles.byKey)
            }
        }
    }
}